import {parseParams} from '@wix/music-shared/dist/src/utils/url';

export enum InitialTransactionStatus {
  'SUCCESS',
  'PENDING',
  'ERROR',
}

export function getTransactionInfo() {
  const {snapshotId, email, transactionStatus} = parseParams();
  const failingStatus = ['DECLINED', 'UNDEFINED', 'BUYER_CANCELED', 'TIMEOUT', 'FAILED', 'ERROR'];
  const pendinStatus = ['PENDING'];
  const successStatus = ['SUCCESS', 'OK'];
  if (transactionStatus && transactionStatus !== 'CANCEL') {
    const isPaymentError = failingStatus.includes(transactionStatus);
    const isPendingPayment = pendinStatus.includes(transactionStatus);
    const isSuccessPayment = successStatus.includes(transactionStatus);
    return {
      transactionStatus: isSuccessPayment
        ? InitialTransactionStatus.SUCCESS
        : isPendingPayment
        ? InitialTransactionStatus.PENDING
        : InitialTransactionStatus.ERROR,
      snapshotId,
      email,
      isPaymentError,
      isPendingPayment,
    };
  }
  return {};
}
